export const SignInConstants = {
  INITIALIZE: "INITIALIZE",
  SIGN_IN: "SIGN_IN",
  SIGN_OUT: "SIGN_OUT",
  SIGN_UP: "SIGN_UP",
  FETCH_MENU_REQUEST: "FETCH_MENU_REQUEST",
  FETCH_MENU_SUCCESS: "FETCH_MENU_SUCCESS",
  FETCH_MENU_FAILURE: "FETCH_MENU_FAILURE",
  FETCH_MENU_WITH_ID_REQUEST: "FETCH_MENU_WITH_ID_REQUEST",
  FETCH_MENU_WITH_ID_SUCCESS: "FETCH_MENU_WITH_ID_SUCCESS",
  FETCH_MENU_WITH_ID_FAILURE: "FETCH_MENU_WITH_ID_FAILURE",
  FETCH_MENU_WITH_ROLE_ID_REQUEST: "FETCH_MENU_WITH_ROLE_ID_REQUEST",
  FETCH_MENU_WITH_ROLE_ID_SUCCESS: "FETCH_MENU_WITH_ROLE_ID_SUCCESS",
  FETCH_MENU_WITH_ROLE_ID_FAILURE: "FETCH_MENU_WITH_ROLE_ID_FAILURE",
  AUTH_USER_AUTO_SEARCH_REQUEST: "AUTH_USER_AUTO_SEARCH_REQUEST",
  AUTH_USER_AUTO_SEARCH_SUCCESS: "AUTH_USER_AUTO_SEARCH_SUCCESS",
  AUTH_USER_AUTO_SEARCH_FAILURE: "AUTH_USER_AUTO_SEARCH_FAILURE",
};
